import React from 'react'
import './Company.css'



const Company = () => {
 
  return (

    <section className='c-wrapper'>
      
        <div className="paddings innerWidth flexCenter c-container">
          
            <img src='./insuranceBroker.png' alt='' />
            <img src='./managementService.png' alt='' />
            <img src='./realtor.png' alt='' />
            <img src='./marketingHub.png' alt='' />
            
        </div>
        
      
    </section>

  
  )
}

export default Company
